var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.contentsOnly)?[_c('v-content',[_c('router-view')],1)]:[_c('the-header'),_c('the-sidebar',{on:{"sidebar":_vm.onChangeSidebar}}),_c('v-content',{staticClass:"mt-5",style:({
        paddingLeft: !_vm.isLogined ? '0px' : _vm.isSidebarOpen ? '256px' : '56px',
      })},[_c('router-view')],1),_c('the-footer')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }